import { apiClient } from './apiClient';

const updateUserProfile = async (data) => {
  return await apiClient.post_form('/profile', data);
};

const getUserProfile = async (data) => {
  return await apiClient.get('/profile', data);
};

export const profileApi = {
  updateUserProfile,
  getUserProfile,
};
